var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "proofreading-waiting" }, [
    !_vm.isFailed
      ? _c(
          "div",
          {
            staticClass: "proofreading-waiting__center",
            class: { "proofreading-waiting__center--stale": _vm.isStaleRefund },
          },
          [
            !_vm.isStaleRefund
              ? _c("CatIcon", {
                  staticClass: "proofreading-waiting__cat",
                  attrs: {
                    size: "large",
                    clickable: false,
                    "aria-hidden": "true",
                  },
                })
              : _vm._e(),
            _c(
              "p",
              {
                staticClass: "proofreading-waiting__message",
                class: {
                  "proofreading-waiting__message--stale": _vm.isStaleRefund,
                },
              },
              [_vm._v(" " + _vm._s(_vm.statusMessage) + " ")]
            ),
            !_vm.isStaleRefund
              ? _c("LoadingSpinner", {
                  staticClass: "proofreading-waiting__spinner",
                  attrs: {
                    size: "medium",
                    variant: "inline",
                    "aria-hidden": "true",
                  },
                })
              : _vm._e(),
            _vm.isFinishing
              ? _c("p", { staticClass: "proofreading-waiting__status" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("proofreadingWaitingPage.finishingHeading")
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.isFinishing && !_vm.isCancelling
              ? _c(
                  "button",
                  {
                    staticClass: "proofreading-waiting__cancel-button",
                    attrs: { type: "button" },
                    on: { click: _vm.onClickCancel },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("proofreadingWaitingPage.cancel")) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "proofreading-waiting__center proofreading-waiting__center--failed",
          },
          [
            _c("CatIcon", {
              staticClass: "proofreading-waiting__cat",
              attrs: { size: "large", clickable: false, "aria-hidden": "true" },
            }),
            _c(
              "p",
              {
                staticClass:
                  "proofreading-waiting__message proofreading-waiting__message--failed",
              },
              [_vm._v(" " + _vm._s(_vm.statusMessage) + " ")]
            ),
            _c("p", { staticClass: "proofreading-waiting__error" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("proofreadingWaitingPage.failedMessage")) +
                  " "
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "proofreading-waiting__back-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickBackToType },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingWaitingPage.backToType")) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }